module.exports = __webpack_public_path__ + "img/profile.72bcaee2.jpg";